<template>
  <section class="about-brands">
    <div class="about-brands__content">
      <div class="about-brands__title">
        <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
        <span>人気ブランドのギフトが</span><span>4,000種類以上！</span>
      </div>
      <div class="about-brands__icons">
        <div class="about-brands__icons-grid">
          <BrandIcon
            v-for="(image, iconIndex) in imageList"
            :key="iconIndex"
            class="about-brands__icon"
            :icon-url="image.src"
            :alt="`${image.brandName} ブランド画像`"
            @click-image="onClickBrandIcon(image.brandId)"
          />
        </div>
      </div>
      <AboutPageSeeMoreButton
        text="ブランドからギフトを選ぶ"
        href="/brands"
        class="about-brands__see-more"
      />
    </div>
  </section>
</template>

<script setup>
import BrandIcon from '../../../atoms/icons/BrandIcon.vue'
import AboutPageSeeMoreButton from '../../../molecules/buttons/AboutPageSeeMoreButton.vue'
import { ref, onMounted } from 'vue'

const imageList = ref([])

onMounted(() => {
  const images = import.meta.glob('../../../../../../images/abouts/brands/*', {
    eager: true
  })
  imageList.value = Object.entries(images).map(([path, module]) => {
    // ファイル名だけ取り出す
    const filename = path.split('/').pop()
    const regExpMatchedFilename = filename.match(
      /^([0-9]*)_([0-9]*)_(.*?)\.(.*?)/
    )
    const brandId = regExpMatchedFilename ? regExpMatchedFilename[2] : 0 // ファイル名は「順番_ブランドID_ブランド名.拡張子」なので、この正規表現の2番目がブランドIDになる。
    const brandName = regExpMatchedFilename ? regExpMatchedFilename[3] : '' // ファイル名は「順番_ブランドID_ブランド名.拡張子」なので、この正規表現の3番目がブランドIDになる。

    return {
      src: module.default,
      brandId,
      brandName
    }
  })
})

const onClickBrandIcon = brandId => {
  location.href = `/brands/${brandId}`
}
</script>

<style lang="scss" scoped>
.about-brands {
  background-color: $gray-3;
  display: flex;
  justify-content: center;

  &__content {
    padding: 96px 72px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    max-width: 1440px;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 48px 24px;
      gap: 24px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding-right: 0;
      width: calc(100% - 24px);
    }
  }

  &__title {
    font-weight: 400;
    font-size: 3.2rem;
    line-height: 160%;
    text-align: center;

    span {
      display: inline;
    }

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 2.4rem;

      span {
        display: block;
      }
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding-right: 24px;
    }
  }

  &__icons {
    @extend %custom-scrollbar;
    margin: auto;

    @media all and (max-width: ($base-contents-width - 1)) {
      width: 100%;
      overflow-x: scroll;
    }
  }

  &__icons-grid {
    width: fit-content;
    display: grid;
    grid-template-rows: repeat(3, 1fr);
    grid-template-columns: repeat(10, 1fr);
    gap: 16px;

    @media all and (max-width: ($pc-width - 1)) {
      gap: 8px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding-right: 24px;
    }
  }

  &__icon {
    width: auto;
    height: auto;

    @media all and (max-width: ($base-contents-width - 1)) {
      width: 72px;
      height: 72px;
    }
  }

  &__see-more {
    @media all and (max-width: ($base-contents-width - 1)) {
      padding-right: 24px;
    }
  }
}
</style>
